// This function is called when an email is suscribed in a newsletter
// See app/views/newsletter_subscfriptions/create.js.erb
function hideAll(message, selector) {
  let $el = $(selector);
  let $alert = $('<div></div>').addClass('alert alert-success').text(message);

  // TO DO - Refactor sidebar-newsletter ---------
  $('.sidebar-newsletter #sidebar-mail').hide();
  $('.sidebar-newsletter .input-text.with-btn').hide();
  $('.sidebar-newsletter .secondary-btn').hide();
  // TO DO - Refactor sidebar-newsletter ---------

  if ($el.length) {
    $el.find('.alert').remove();
    $el.find('[data-hide]').hide();
    $el.find('[data-show-alert]').after($alert);
  }

  $('.footer-newsletter [data-hide]').hide();
  $('.sidebar-newsletter').append(message);
  $('.footer-contact .newsletter').hide();
}

function showAlert(message, selector) {
  let $el = $(selector);
  let $alert = $('<div></div>').addClass('alert alert-warning').text(message);

  if ($el.length) {
    $el.find('.alert').remove();
    $el.find('[data-show-alert]').after($alert);
    $el.find('[name=email]').val('').focus();
  }
}

window.IB.newsletter = {
  hideAll:   hideAll,
  showAlert: showAlert
};


$(function () {
  if ($.cookie('hide_newsletter') && $.cookie('hide_newsletter') === 'true') {
    let datalayer = JSON.parse(sessionStorage.getItem('utag_user'));

    $('.footer-contact .newsletter').hide();
    $('.sidebar-newsletter').hide();

    let $el = $('.footer-newsletter');

    if ($el.length) {
      if (datalayer != null && datalayer != '' && datalayer.page_is_logged !== undefined && datalayer.page_is_logged == 'true') {
        $el.filter('[data-show-alternative="0"]').hide();
      }
      $el.find('[data-hide-newsletter]').map(function (item) {
        let $this = $(this);
        $this.html($this.data('hide-newsletter'));
      });

      $el.find('[data-hide]').hide();
    }
  } else {
    let $el = $('.footer-newsletter');

    if ($el.length) {
      $el.find('[data-show-newsletter]').map(function (item) {
        let $this = $(this);
        $this.html($this.data('show-newsletter'));
      });
    }
  }
});
